<template>
<div class="overlay" id="quote-modal">
  <a class="close" @click="closeModal()"> </a>
  <div class="container">
    <div>
      <div class="form-block">
        <div>
          <header>
            <h1 v-t="'Header'"></h1>
          </header>
          <p v-t="'Paragraph1'"></p>
          <p v-t="'Paragraph2'"></p>
        </div>
          <div class="form-row">
            <div class="col">
              <div class="form-group submit">
                <sb-button v-t="'Button'"
                variation="primary"
                @click='modalSubmitted()'
                id="goLive"
                color="blue">
                </sb-button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <fade-transition :mode="'out-in'">
    <loading v-if="showLoadScreen"></loading>
  </fade-transition>
</div>
</template>

<script>
  import Loading from '@/components/general/Loading'
  import GetStartedStep from '@/models/dashboard/getStartedStep'
  import GetStartedStepsEnum from '@/enums/modules/setup/getStartedSteps'
  export default {
    name: 'ClearDemoDataModal',
    components: {
      Loading
    },
    data () {
      return {
        initialLoad: true,
        showLoadScreen: false
      }
    },
    computed: {
    },
    methods: {
      closeModal () {
        this.$emit('close-modal')
      },
      modalSubmitted () {
        this.$emit('modal-submitted')
        this.goLive()
      },
      async goLive () {
        this.$shipBobStore.dispatch('setupDashboard/goLive')
        this.$shipBobStore.dispatch('setupDashboard/setGetStartedStep', new GetStartedStep({
          ItemId: GetStartedStepsEnum.ClearDemoData,
          IsCompleted: true
        }))
      }
    },
    i18n: {
      messages: {
        'en-US': {
          Header: 'Clear your account of demo data!',
          Paragraph1: 'When you signed up for your free trial of ShipBob\'s fulfillment software, we populated your account with dummy products and orders, so you could see how it works.',
          Paragraph2: 'Before you finish your account setup, you\'ll just need to delete this dummy data by clicking below.',
          Button: 'Clear Demo Data'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import '@/../assets/scss/shipbob-custom/components/dashboard/_clear-demo-data-modal.scss';
</style>